<oth-card
    *ngIf="feature.title"
    [bodyTemplate]="bodyTemplate"
    [headerTemplate]="headerTemplate"
    class="feature-card">
  <ng-template #headerTemplate>
    <div class="header">
      <i [class]="feature.icon" aria-hidden="true"></i>
      <p>{{ feature.title }}</p>
    </div>
  </ng-template>
  <ng-template #bodyTemplate>
    <div class="body">
      <p>{{ feature.description }}</p>
    </div>
  </ng-template>
</oth-card>
